// 封装游戏分类页的组件以及数据获取
import { getDeviceType } from "@/utils/device";
import { getAllGames, getCategoryGame, getGameCover } from "@/api/header";
import { formatCover } from "@/utils/methods";
import PageDetail from "@/pages";

// 游戏分类页面
export function MenuPageDetail({initialGames, initialDeviceType, initialTotal}) {
    return <PageDetail
        isSlugPage={true}
        initialGames={initialGames}
        initialDeviceType={initialDeviceType}
        initialTotal={initialTotal}
    />;
}

// 游戏分类页面的服务端数据获取
export const getMenuServerSideProps = async context => {
    const userAgent = context.req.headers['user-agent'] || '';
    const deviceType = getDeviceType(userAgent);
    const limit = 200;
    const { slug } = context.query;

    try {
        const res = await (slug ?
            getCategoryGame({ category_path: slug, limit, offset: 0 }) :
            getAllGames({ limit, offset: 0, order: 'desc', sortby: 'create_at' }));

        if (!res?.data?.results) {
            throw new Error('无效的API响应结构');
        }

        let { results, total } = res.data;
        const params = {
            game_ids: results.map((game) => game.id).join(','),
        }

        const coverRes = await getGameCover(params);

        const { results: gameCoversMap } = coverRes.data;
        results = results.map((game) => {
            let cover_image = gameCoversMap[game.id];
            if (cover_image) {
                cover_image = formatCover(cover_image);
            }
            return {
                ...game,
                loading: false,
                cover_image: cover_image || "/images/icons/common/placeholder.jpg",
            };
        });

        return {
            props: {
                page_name: '/',
                initialDeviceType: deviceType,
                initialGames: results,
                initialTotal: total
            }
        };
    } catch (error) {
        console.error('=== 服务端渲染错误 ===', {
            name: error.name,
            message: error.message,
            stack: error.stack
        });
        return {
            props: {
                page_name: '/',
                initialDeviceType: deviceType,
                initialGames: [],
                initialTotal: 0,
                error: process.env.NODE_ENV === 'development' ? {
                    message: error.message,
                    stack: error.stack
                } : undefined
            }
        };
    }
};